import { render } from "./BaseCard.vue?vue&type=template&id=ae60010c&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=ae60010c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae60010c"]])

export default __exports__